import { defineComponent } from 'vue';
export default defineComponent(() => {
  const goContactus = () => {
    window.open('/software-platform/contactus');
  };
  return {
    goContactus
  };
});